import { Component } from '@angular/core';

@Component({
  selector: 'app-index-pricing-section',
  imports: [],
  templateUrl: './index-pricing-section.html',
  styleUrl: './index-pricing-section.scss',
})
export class IndexPricingSection {

}
